import * as React from 'react';
import { IRestBoardCopyActivity } from '../../../../../../../../types/rest/activity/IRestBoardCopyActivity';
import { IActivityProps } from '../../types';
import { TActivity } from '../../../../../../../../store/activities/types';
import { ActivityItemBody } from '../ActivityItemBody/ActivityItemBody';
import { ActivityHeader } from '../ActivityHeader/ActivityHeader';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`BoardActivityCopy`) : null;

export function BoardActivityCopy ({
    activity
}: IActivityProps<IRestBoardCopyActivity>) {
    if (analyzeRender) analyzeRender.call(activity.id);
    const copiedFrom: IRestBoardCopyActivity = {
        ...activity,
        dashboard: {
            id: Number(activity.copiedFromId),
            name: activity.oldValue
        }
    }
    const { label } = activity as TActivity;
    return (
        <ActivityItemBody
            header={<ActivityHeader label={label} />}
            activity={copiedFrom}
        />
    );
}
